import HeaderTitle from "../../components/guest/HeaderTitle";
import GuestLayout from "../../layouts/GuestLayout";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

export default function Vision() {
    useEffect(() => {
        AOS.init();
        AOS.refresh();
    }, [])
    return (
        <GuestLayout title="The Vision">
            <HeaderTitle title="The Vision" />
            <div className="blue-bg wrapper py-20 text-white">
                <div className="grid md:grid-cols-1 grid-cols-1 gap-8">
                    <div data-aos="fade-in" className="flex flex-col justify-start border-2 border-gray-100 px-4 py-6 rounded-xl">
                        <p className="text-justify">
                            To contribute to the progressive advancement of alternative dispute resolution (ADR) approaches, using technology. Accordingly, to foster acceptance and the efficient and sustainable development of online dispute resolution (ODR) Globaly.
                        </p>
                    </div>

                    <div data-aos="fade-in" className="flex flex-col justify-start border-2 border-gray-100 px-4 py-6 rounded-xl">
                        <p className="text-justify">
                            To contribute significantly to the development of systems that enable the settlement of disputes arising from commercial transactions and general interactions, in a manner that does not impose costs, delays and burdens that are disproportionate to the economic value at stake.
                        </p>
                    </div>

                    <div data-aos="fade-in" className="flex flex-col justify-start border-2 border-gray-100 px-4 py-6 rounded-xl">
                        <p className="text-justify">
                            To provide an alternative for addressing situations arising out of transactions for which legal recourse under traditional judicial mechanisms may not offer an adequate and timely solution.
                        </p>
                    </div>
                    <div data-aos="fade-in" className="flex flex-col justify-start border-2 border-gray-100 px-4 py-6 rounded-xl">
                        <p className="text-justify">
                            To facilitate the consensual, speedy and amicable resolution of civil disputes in a simple, flexible, convenient, and enforceable manner, without the need for physical presence.
                        </p>
                    </div>

                    <div data-aos="fade-in" className="flex flex-col justify-start border-2 border-gray-100 px-4 py-6 rounded-xl">
                        <p className="text-justify">
                            To aid the needed re-distribution of judicial resources to matters of weightier national, fiscal and policy latitudes and those affecting the rights, livelihood and liberty of the person.
                        </p>
                    </div>
                </div>
            </div>
        </GuestLayout>
    );
}